<app-statistik-kunder-options class="d-flex" (periodeChange)="onPeriodeChange($event)"
                              (selectKundeAnsvarlig)="onKundeAnsvarligSelected($event)"
                              (selectLedelseAnsvarlig)="onLedelseAnsvarligSelected($event)"
                              (selectMedarbejderID)="onMedarbejderSelected($event)"
                              (selectKoncern)="onKoncernSelected($event)"
                              (selectDecimal)="onDecimalSelected($event)"
                              (selectHourFormat)="onHourFormatSelected($event)"
                              (selectDeciminuts)="onDeciminutsSelected($event)"
                              (selectRemoveAfsluttet)="onRemoveAfsluttetSelected($event)"
                              (exportExcel)="onExport()"
                              [kaCards]="kaCards"
                              [laCards]="laCards"
                              [medarbejdere]="medarbejdere"
                              [koncerns]="koncernList"
                              [periode]="periode"
                              [selectedMedarbejder]="selectedMedarbejderId"
></app-statistik-kunder-options>

<div class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
        <tr>
            <th>Kunde</th>
            <ng-container *ngFor="let monthIndex of monthIndexArray">
                <th colspan="2" class="text-center">{{getMonth(monthOrder[monthIndex])}}</th>
            </ng-container>

            <th colspan="2" class="text-center">I alt</th>
        </tr>
        <tr>
            <th></th>
            <ng-container *ngFor="let monthIndex of monthIndexArray">
                <th class="text-center">P</th>
                <th class="text-center">R</th>
            </ng-container>
            <th class="text-center">P</th>
            <th class="text-center">R</th>
        </tr>
        </thead>

        <tbody>
        <ng-container *ngFor="let kunde of filteredStatistikKunder; trackBy: trackKundeID">
            <tr class="item__tr">
                <td (click)="navigateToClientBasis(kunde)" class="link-td">
                    {{resizeNameLength(kunde)}}
                </td>
                <ng-container *ngFor="let monthIndex of monthIndexArray">
                    <td (click)="openSagModal(kunde, monthOrder2[monthIndex])" class="link-td text-end">
                        {{ getTimeBudget(kunde, monthOrder2[monthIndex], hourFormat) | timeKrFormat : hourFormat : decimal : inDeciminuts : true }}
                    </td>

                    <td class="normtid text-end">
                        {{getTimeRegistrations(kunde, monthOrder[monthIndex], hourFormat) | timeKrFormat: hourFormat : decimal : inDeciminuts : true }}
                    </td>
                </ng-container>

                <td class="text-end">
                    {{getTotalTimeBudget(kunde, hourFormat) | timeKrFormat: hourFormat: decimal: inDeciminuts : true }}
                </td>
                <td class="text-end">
                    {{getTotalTimeRegistrations(kunde, hourFormat) | timeKrFormat: hourFormat: decimal: inDeciminuts : true }}
                </td>
            </tr>
        </ng-container>
        </tbody>

        <tfoot class="fixed-bottom position-fixed position-sticky">
        <tr>
            <th>I alt</th>
            <ng-container *ngFor="let monthIndex of monthIndexArray">
                <th class="text-end"> {{getTotalMontlyTimeBudget(filteredStatistikKunder, monthOrder2[monthIndex], hourFormat) | timeKrFormat: hourFormat: decimal: inDeciminuts: true }} </th>
                <th class="text-end"> {{getTotalMontlyTimeRegistrations(filteredStatistikKunder, monthOrder[monthIndex], hourFormat) | timeKrFormat: hourFormat: decimal: inDeciminuts: true }} </th>
            </ng-container>

            <th class="text-end"> {{getTotalYearlyTimeBudget(filteredStatistikKunder, hourFormat)|  timeKrFormat: hourFormat: decimal: inDeciminuts: true}} </th>
            <th class="text-end"> {{getTotalYearlyTimeRegistrations(filteredStatistikKunder, hourFormat)|  timeKrFormat: hourFormat: decimal: inDeciminuts: true}} </th>
        </tr>

        <ng-container *ngIf="selectedMedarbejderId">
            <tr>
                <th>Plantid /Norm tid for Medarbejder</th>
                <ng-container *ngFor="let monthIndex of monthIndexArray">
                    <th class="link-td text-end" (click)="openPlanlagtTimerModal(getMedarbejderTotalTimeBudgets(monthOrder2[monthIndex]), monthOrder2[monthIndex])" > {{getMedarbejderTotalTimeBudgets(monthOrder2[monthIndex]) |  timeKrFormat: hourFormat: decimal: inDeciminuts: true}} </th>
                    <th class="text-end"> {{getMedarbejderNormTid(monthOrder[monthIndex]) | timeKrFormat: hourFormat: decimal: inDeciminuts: true}} </th>
                </ng-container>
            </tr>
        </ng-container>

        </tfoot>

    </table>
</div>
